import { useSeo } from "@/hooks/useSeo";
import Hero from "@/components/sections/Hero";
import StatsBand from "@/components/sections/StatsBand";
import ClientMarquee from "@/components/sections/ClientMarquee";
import ClientsWall from "@/components/sections/ClientsWall";
import FeaturedWork from "@/components/sections/FeaturedWork";
import Capabilities from "@/components/sections/Capabilities";
import TeamFun from "@/components/sections/TeamFun";
import IndustriesTeaser from "@/components/sections/IndustriesTeaser";
import WhyHashtag from "@/components/sections/WhyHashtag";
import FoundersSection from "@/components/sections/FoundersSection";
import Testimonials from "@/components/sections/Testimonials";
import CTASection from "@/components/sections/CTASection";

export default function Home() {
  useSeo({
    description:
      "Independent integrated marketing agency in Gurgaon, Delhi NCR. 15+ years of brand strategy, creative, digital, PR, events and exhibitions for brands across India.",
    path: "/",
  });
  return (
    <>
      <Hero />
      <StatsBand />
      <ClientMarquee />
      <FeaturedWork />
      <Capabilities />
      <TeamFun />
      <IndustriesTeaser />
      <FoundersSection />
      <Testimonials />
      <WhyHashtag />
      <ClientsWall />
      <CTASection />
    </>
  );
}
